<div class="navbar-bottom login-container">

  <!-- Page container -->
  <div class="page-container">

    <!-- Page content -->
    <div class="page-content">

      <!-- Main content -->
      <div class="content-wrapper">

        <form name="loginForm">
          <div class="panel panel-body login-form">
            <div class="text-center">
              <!-- <div class="icon-object border-slate-300 text-slate-300"><i class="icon-reading"></i></div> -->
              <div class="icon-object border-slate-300 text-slate-300"><img src="assets/images/user.jpg" width="50"
                  height="50"></div>
              <h5 class="content-group">Login <small class="display-block">Enter your credentials
                  below</small></h5>
              <p style="color:red" *ngIf='loginError'>{{loginError}}</p>
              <p style="color:darkgreen" *ngIf='authenticating'>Authenticating . . .</p>
            </div>

            <div class="form-group has-feedback has-feedback-left">
              <input name="email" type="email" class="form-control" placeholder="Username" [(ngModel)]='auth.username'>
              <div class="form-control-feedback">
                <i class="icon-user text-muted"></i>
              </div>
            </div>

            <div class="form-group has-feedback has-feedback-left">
              <input type="password" name="password" class="form-control" placeholder="Password"
                [(ngModel)]='auth.password'>
              <div class="form-control-feedback">
                <i class="icon-lock2 text-muted"></i>
              </div>
            </div>

            <p ng-model="vm.loginError"></p>
            <div class="form-group">
              <button (click)='login()' class="btn bg-slate-800 btn-block">Sign in </button>
            </div>
          </div>
        </form>
        <!-- /simple login form -->

      </div>
      <!-- /main content -->

    </div>
    <!-- /page content -->

  </div>
  <!-- /page container -->

</div>